import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import css from "../styles_web/HeaderMenuDropdown.module.css";

/************************************/
/* Header Menu Content Dropdown */
/************************************/
const HeaderMenuContentDropdown = ({className, children}) => {
  return (
    <div
      className={classNames([css["nav-shop-dropdown"]], {
        [className]: className,
      })}>
      <div className={css["dropdown-container"]}>
        {children}
      </div>
    </div>
  );
};

HeaderMenuContentDropdown.propTypes = {
  className: PropTypes.string
};

/************************************/
/* Header Menu Nav Dropdown */
/************************************/
const HeaderMenuNavDropdown = React.forwardRef(({menuItems, className, onItemClick, onMouseEnter, onMouseLeave}, ref) => {
  return (
    <div ref={ref}
      className={classNames([css["nav-dropdown"]], {
        [className]: className,
      })}>
      <div className={css["nav-submenu-links"]} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {menuItems.map((item) => <div key={item.title} onClick={() => onItemClick(item)}><Link to={item.link}>{item.title}</Link></div>)}
      </div>
    </div>
  );
});

HeaderMenuNavDropdown.propTypes = {
  menuItems: PropTypes.array.isRequired,
  className: PropTypes.string,
  onItemClick: PropTypes.func,
};

export { HeaderMenuNavDropdown, HeaderMenuContentDropdown };
